import { todayNodeName } from "motw_core/Repositories/WorkflowRepository";
import { GoToWorkflowNodeForInput } from "source/app/presentation/BottomBar/BottomLeftDashboard/NextActionLink/NextActionLink";
import { GetWorkflowsState } from "source/app/presentation/MainPanel/Workflows/Workflows";
import { EPanelId } from "source/app/services/Shared/EPanelId";
import {
    IKeyboardEvent,
    TKeyboardEvent,
} from "source/app/services/UI/KeyboardEvents/IKeyboardEvents";
import {
    dollaramaNodeName,
    noFrillsNodeName,
    survivalGuideNodeName,
    utterancesNodeName,
} from "source/app/services/Workflows/NodeNameConstants";
import { GotoNodeAsync, GotoParentAsync } from "../../../Workflows/GotoNode";
import { GoToLatestDiaryEntryAsync } from "./GoToLatestDiaryEntryAsync";

const GoToRandomlySelectedNode: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + x`,
    actionDescription: `Go to randomly selected node`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 88,
    conditions: [
        {
            when: EPanelId.Workflows,
            do: () => {
                const workflows = GetWorkflowsState().state;
                GotoNodeAsync(workflows.randomNode.name);
            },
        },
    ],
};

const GoToTodayNode: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + t`,
    actionDescription: `Go to Today Tasks`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 84,
    conditions: [
        {
            when: EPanelId.Workflows,
            do: () => GoToWorkflowNodeForInput(todayNodeName),
        },
    ],
};

const GoToLatestUtteranceNode: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + F1`,
    actionDescription: `Go to latest utterance`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 112,
    conditions: [
        {
            when: EPanelId.Workflows,
            do: () => GotoNodeAsync(utterancesNodeName),
        },
    ],
};

const GoToSurvivalGuideNode: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + b`,
    actionDescription: `Go to Survival Guide node`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 66,
    conditions: [
        {
            when: EPanelId.Workflows,
            do: () => GotoNodeAsync(survivalGuideNodeName),
        },
    ],
};

const GoToDiaryEntriesNode: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + 1`,
    actionDescription: `Go to Diary Entries node`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 49,
    conditions: [
        {
            when: EPanelId.Workflows,
            do: async () => GoToLatestDiaryEntryAsync(),
        },
    ],
};

// const GoToParentNode: IKeyboardEvent = {
//     hotkeyDescription: `Ctrl + Alt + Up`,
//     actionDescription: `Go to parent node`,
//     trigger: (event: TKeyboardEvent) =>
//         event.ctrlKey && event.altKey && event.keyCode == 38,
//     conditions: [
//         {
//             when: EPanelId.Workflows,
//             do: async () => {
//                 const workflows = GetWorkflowsState();
//                 const currentNode = workflows.state.rootNode;
//                 await GotoParentAsync(currentNode);
//             },
//         },
//     ],
// };

const GoToNoFrillsNode: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + n`,
    actionDescription: `Go to No Frills node`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 88,
    conditions: [
        {
            when: EPanelId.Workflows,
            do: () => GoToWorkflowNodeForInput(dollaramaNodeName),
        },
    ],
};

const GoToDollaramaNode: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + x`,
    actionDescription: `Go to Dollarama node`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 78,
    conditions: [
        {
            when: EPanelId.Workflows,
            do: () => GoToWorkflowNodeForInput(noFrillsNodeName),
        },
    ],
};

const GoToNodeSearchBox: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + f`,
    actionDescription: `Go to Node search box`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && !event.shiftKey && event.keyCode == 70,
    conditions: [
        {
            when: EPanelId.Workflows,
            do: () => GoToWorkflowNodeForInput(undefined),
        },
    ],
};

export const workflowsKeyboardEvents: IKeyboardEvent[] = [
    GoToRandomlySelectedNode,
    GoToSurvivalGuideNode,
    // GoToParentNode,
    GoToNoFrillsNode,
    GoToDollaramaNode,
    GoToTodayNode,
    GoToLatestUtteranceNode,
    GoToNodeSearchBox,
    GoToDiaryEntriesNode,
];
